import './Register.css'
import Heart from "../../App/Heart/Heart";
import Connection from "../Connection/Connection";
import {FormRegister} from "./FormRegister";
import Turnstile from "react-turnstile";
import React from "react";

class Register extends Heart {
    constructor(props) {
        super(props);
        this.state = {
            alerts: '',
            captchaToken: null,
            captchaKey: Date.now(),
        }
    }
    render() {
        this.inputs = []
        return (
            <div className="Register">
                <FormRegister
                    refSubmit={this.refSubmit}
                    setAlert={(message, variant, dismissible) => this.setAlert(message, variant, dismissible)}
                    handleSubmit={(e) => this.handleSubmit(e)}
                    refForm={this}
                    alerts={this.state.alerts}
                />
                {process.env.REACT_APP_CLOUDFLARE_TURNSTILE_ACTIF === "true" && (
                  <div className="captcha-container text-center my-3">
                    <Turnstile
                        key={this.state.captchaKey}
                        sitekey={process.env.REACT_APP_CLOUDFLARE_TURNSTILE_ACTIF_KEY}
                        options={{theme: 'dark', size: 'invisible', language: 'fr'}}
                        onVerify={(token) => {
                            this.setState({ captchaToken: token });
                        }}
                        onExpire={() => {
                          console.warn("Turnstile expiré");
                            this.setState({ captchaToken: null });
                        }}
                        onError={() => {
                          console.error("Erreur Turnstile");
                            this.setState({ captchaToken: null });
                        }}
                    />
                  </div>
                )}
                <p className={"text-center"} style={{fontWeight: 400}}>
                    <span>Vous avez déjà un compte ? </span>
                    <a
                        href={"/utilisateur/connexion"}
                        className={"text-primary"}
                        style={{fontWeight: 600}}
                        onClick={(event) => {
                          event.preventDefault()
                          this.handleNextComponent(<Connection Accueil={this.props.Accueil} App={this.props.App} />)
                        }}
                    >Me connecter</a>
                </p>
            </div>
        );
    }
    handleSubmit(event) {

        /** Annule l'évènement navigateur */
        event.preventDefault();

        /** Déclaration des events */
        let Champ = {
            psNom: document.getElementById("name").value,
            psPrenom: document.getElementById("firstName").value,
            psEmail: document.getElementById("mail").value,
            psMotDePasse: document.getElementById("password").value
        }
        let submit = document.getElementById("RegisterAccount")
        submit.classList.add('disabled')
        submit.setAttribute('disabled', true)

      if (process.env.REACT_APP_CLOUDFLARE_TURNSTILE_ACTIF==="true")
      {
          this.props.App.Utilisateur.CloudFlareTurnstile(this.state.captchaToken).then((data) => {
              if (data.success) {
                  this.props.App.Utilisateur.Registrer(Champ).then(() => {
                      this.setAlert(<>Votre compte unique de l’école des loisirs est maintenant créé. <br />Il vous permettra de vous connecter à tous les sites du groupe école des loisirs.</>, 'success')
                      setTimeout(() => {
                          this.handleNextComponent(<Connection Accueil={this.props.Accueil} App={this.props.App} />)
                      }, 4000);
                  }, sortie => {
                      this.setAlert(sortie.message)
                      submit.classList.remove('disabled')
                      submit.removeAttribute('disabled')
                      this.setState({
                        captchaToken: null,
                        captchaKey: Date.now()
                      });
                  })
              } else {
                  this.setAlert("Échec de la validation Cloudflare Turnstile.")
                  submit.classList.remove('disabled')
                  submit.removeAttribute('disabled')
              }
          }).catch((err) => {
              this.setAlert(err.message || "Erreur lors de la vérification du captcha.");
              submit.classList.remove('disabled');
              submit.removeAttribute('disabled');
          });
      } else {
          this.props.App.Utilisateur.Registrer(Champ).then(() => {
              this.setAlert(<>Votre compte unique de l’école des loisirs est maintenant créé. <br />Il vous permettra de vous connecter à tous les sites du groupe école des loisirs.</>, 'success')
              setTimeout(() => {
                this.handleNextComponent(<Connection Accueil={this.props.Accueil} App={this.props.App} />)
              }, 4000);
          }, sortie => {
              this.setAlert(sortie.message)
              submit.classList.remove('disabled')
              submit.removeAttribute('disabled')
          })
      }
    }
    handleFormChange() {
        this.handleFormChangeAll()
    }
}

export default Register